import(/* webpackMode: "eager" */ "/private/tmp/statura-proddeploy-TUaNgM/apps/web/src/app/global-error.tsx");
